module.exports = __webpack_public_path__ + "img/academy.678c33e9.jpg";